import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import ProposalIcon from 'assets/icons/Proposal.svg?react';
import { Proposal } from 'views/Case/Proposal';
import { CaseProposal } from 'pco-product-service-internal-consumer';

const styles = {
  card: {
    maxWidth: '90%',
    marginTop: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  container: {
    paddingLeft: theme.spacing(2),
  },
  icon: {
    marginTop: theme.spacing(2),
  },
  cardContent: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(1),
  },
};

type Props = {
  proposals: CaseProposal[];
};

export const Proposals = ({ proposals }: Props) => (
  <Card data-testid="proposals" sx={styles.card} square>
    <Grid container sx={styles.container}>
      <ProposalIcon style={styles.icon} />
      <CardHeader sx={styles.title} title={'PROPOSALS'} titleTypographyProps={{ variant: 'subtitle1' }} />
    </Grid>
    <CardContent sx={styles.cardContent}>
      <Grid container direction={'column'}>
        {proposals.length === 0 && <Typography variant={'caption'}>No proposals added yet</Typography>}
        {proposals.map((caseProposal, i) => (
          <Proposal key={`proposal-key-${caseProposal.proposalName}-${i}`} proposal={caseProposal} />
        ))}
      </Grid>
    </CardContent>
  </Card>
);
